
export class CreateGroupRequest {
    public userPk: number;
    public studyGroupName: string;
    public protocolFk: number[] = [];

    constructor(userPk: number, groupname: string, protocolFk: number[]) {
        this.userPk = userPk;
        this.studyGroupName = groupname;
        this.protocolFk = protocolFk;
    }
}
